"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_handler_manager_1 = require("event-handler-manager");
var SingleStyleInjector_1 = require("./SingleStyleInjector");
var StylesPathBuilder_1 = require("./StylesPathBuilder");
var StylesInjector_1 = require("./StylesInjector");
var StylesConfigProvider_1 = require("./StylesConfigProvider");
var StylesLoader = /** @class */ (function (_super) {
    __extends(StylesLoader, _super);
    function StylesLoader(stylesConfigProvider, stylesInjector, document, singleStyleInjector, stylesPathBuilder) {
        var _this = _super.call(this) || this;
        _this.stylesConfigProvider = stylesConfigProvider;
        _this.stylesInjector = stylesInjector;
        _this.document = document;
        _this.singleStyleInjector = singleStyleInjector;
        _this.stylesPathBuilder = stylesPathBuilder;
        _this.modules = {};
        _this.attach(['beforeload', 'afterload']);
        _this.stylesConfigProvider = _this.stylesConfigProvider !== undefined && _this.stylesConfigProvider !== null
            ? _this.stylesConfigProvider
            : new StylesConfigProvider_1.StylesConfigProvider();
        _this.document = document !== undefined && document !== null
            ? document
            : window.document;
        _this.singleStyleInjector = _this.singleStyleInjector !== undefined && _this.singleStyleInjector !== null
            ? _this.singleStyleInjector
            : new SingleStyleInjector_1.SingleStyleInjector(_this.document);
        _this.stylesPathBuilder = _this.stylesPathBuilder !== undefined && _this.stylesPathBuilder !== null
            ? _this.stylesPathBuilder
            : new StylesPathBuilder_1.StylesPathBuilder();
        _this.stylesInjector = _this.stylesInjector !== undefined && _this.stylesInjector !== null
            ? _this.stylesInjector
            : new StylesInjector_1.StylesInjector(_this.singleStyleInjector);
        return _this;
    }
    StylesLoader.prototype.load = function () {
        var _this = this;
        this.trigger('beforeload', true);
        this.stylesConfigProvider.get().then(function (stylesConfig) {
            _this.stylesInjector.inject(_this, stylesConfig);
            _this.trigger("afterload", true);
        });
    };
    return StylesLoader;
}(event_handler_manager_1.EventHandlerManager));
exports.StylesLoader = StylesLoader;
//# sourceMappingURL=StylesLoader.js.map